// Leona Eclipse VFX: solar shield glow expanding around the caster.

import type { Animation } from "../../engine/animation/AnimationQueue";
import { Easing } from "../../engine/animation/Easing";
import type { Point } from "../../engine/hex/HexLayout";

const DURATION = 500;

export class ShieldVFX implements Animation {
  private elapsed = 0;

  constructor(
    private center: Point,
    private radius: number = 28,
  ) {}

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, DURATION);
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const t = this.elapsed / DURATION;
    const expandT = Easing.easeOutBack(Math.min(t * 2, 1));
    const alpha = t < 0.5 ? 1 : 1 - (t - 0.5) * 2;

    ctx.save();

    // Outer glow ring
    ctx.globalAlpha = alpha * 0.5;
    ctx.strokeStyle = "#ffd700";
    ctx.lineWidth = 6;
    ctx.shadowColor = "#ffd700";
    ctx.shadowBlur = 24;
    ctx.beginPath();
    ctx.arc(this.center.x, this.center.y, this.radius * expandT, 0, Math.PI * 2);
    ctx.stroke();

    // Inner warm fill
    ctx.globalAlpha = alpha * 0.25;
    ctx.fillStyle = "#ffa500";
    ctx.beginPath();
    ctx.arc(this.center.x, this.center.y, this.radius * expandT * 0.7, 0, Math.PI * 2);
    ctx.fill();

    // Sun flare lines
    ctx.globalAlpha = alpha * 0.6;
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 1.5;
    for (let i = 0; i < 8; i++) {
      const angle = (i / 8) * Math.PI * 2 + t * Math.PI;
      const innerR = this.radius * expandT * 0.8;
      const outerR = this.radius * expandT * 1.1;
      ctx.beginPath();
      ctx.moveTo(
        this.center.x + Math.cos(angle) * innerR,
        this.center.y + Math.sin(angle) * innerR,
      );
      ctx.lineTo(
        this.center.x + Math.cos(angle) * outerR,
        this.center.y + Math.sin(angle) * outerR,
      );
      ctx.stroke();
    }

    ctx.restore();
  }

  isDone(): boolean {
    return this.elapsed >= DURATION;
  }
}
